import React from "react";

function NotFound() {
  return <div>404 page not found</div>;
}

export default NotFound;
